/**
 * OrbDocTutorialsIntermediateGuardsARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsIntermediateGuardsARDocScreen
 */

import { useOrbDocTutorialsIntermediateGuardsARDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsIntermediateGuardsARDocScreenLogic';
import type { OrbDocTutorialsIntermediateGuardsARDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsIntermediateGuardsARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsIntermediateGuardsARDocView as OrbDocTutorialsIntermediateGuardsARDocViewEntity } from '@app/shared';
import { OrbDocTutorialsIntermediateGuardsARDocBodyView } from '@/components/traits/OrbDocTutorialsIntermediateGuardsARDocBodyView';
import { OrbDocTutorialsIntermediateGuardsARDocFooterView } from '@/components/traits/OrbDocTutorialsIntermediateGuardsARDocFooterView';
import { OrbDocTutorialsIntermediateGuardsARDocHeaderView } from '@/components/traits/OrbDocTutorialsIntermediateGuardsARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsIntermediateGuardsARDocScreenViewProps {
  config?: Partial<OrbDocTutorialsIntermediateGuardsARDocScreenConfig>;
}

export function OrbDocTutorialsIntermediateGuardsARDocScreenView({ config: propsConfig }: OrbDocTutorialsIntermediateGuardsARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsIntermediateGuardsARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsIntermediateGuardsARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsIntermediateGuardsAR" trait="OrbDocTutorialsIntermediateGuardsARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsIntermediateGuardsARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsIntermediateGuardsARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateGuardsARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateGuardsARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsIntermediateGuardsARDocScreenView;
